import React, { FunctionComponent } from 'react';

const PlusIcon: FunctionComponent = () => (
  <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.852 6.522V4.308H7.37V0.0149998H5.183V4.308H0.809V6.522H5.183V10.842H7.37V6.522H11.852Z" fill="white" />
  </svg>
);

export default PlusIcon;
